
<section id="escolas" class="section-bg">
  <div class="container">
    <header class="section-header">
      <h3 class="section-title">Nossas Escolas</h3>
    </header>

    <div class="row">
      <div class="col-lg-12">
        <ul id="escolas-flters">
          <li
            [class.filter-active]="filtro_escolas == 'Creche'"
            (click)="filtro_escolas = 'Creche'"
          >
            Creche
          </li>
          <li
            [class.filter-active]="filtro_escolas == 'CrecheInfantil'"
            (click)="filtro_escolas = 'CrecheInfantil'"
          >
            Creche e Educação Infantil
          </li>
          <li
            [class.filter-active]="filtro_escolas == 'Infantil'"
            (click)="filtro_escolas = 'Infantil'"
          >
            Educação Infantil
          </li>
          <li
            [class.filter-active]="filtro_escolas == 'InfantilFundamental'"
            (click)="filtro_escolas = 'InfantilFundamental'"
          >
            Educação Infantil e Ensino Fundamental
          </li>
          <li
            [class.filter-active]="filtro_escolas == 'Fundamental'"
            (click)="filtro_escolas = 'Fundamental'"
          >
            Ensino Fundamental
          </li>
          <li
            [class.filter-active]="filtro_escolas == 'CEMAD'"
            (click)="filtro_escolas = 'CEMAD'"
          >
            CEMAD
          </li>
        </ul>
      </div>
    </div>

    <div class="row" matchHeight="card">
      <ng-container *ngFor="let escola of api.escolas$ | async">
        <div
          *ngIf="!filtro_escolas || filtro_escolas == escola.tipo"
          data-wow-duration="2s"
          class="col-lg-3 col-md-4 col-sm-6 mb-4 d-flex escolas-item"
        >
         <div class="escolas-wrap">
           <figure class="escolas-image">
               <a
              *ngIf="escola.foto"
              href="{{ escola.foto }}"
              data-lightbox="escolas"
              data-title="{{ escola.nome }}"
              title="Ver Foto"
              class="teste"
            >
            
              <img [src]="escola.foto" class="card-img-top teste" />
            </a>
            </figure>
            
  <div class="escolas-info" style="height: 190px;">
                  <p>{{ escola.nome }}</p>
    <a class="color"
      [href]="getGoogleMapsLink(escola.localizacao)"
      target="_blank"
      rel="noopener"
      aria-label="Abrir localização no Google Maps"
    > 
      📍 {{ escola.localizacao }}
    </a>

  <p style="color: #007bff;">Telefone: {{ escola.telefone }}</p>
           </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>